



















import { Component, Vue } from 'vue-property-decorator'

import AuthModal from '@/components/AuthModal.vue'
import ResetPasswordForm from '@/components/ResetPasswordForm.vue'

import ResetPasswordFormData from '@/models/reset-password-form-data'

import { AuthActionTypes } from '@/store/modules/auth/actions'

import ErrorEntities from '../models/error-entities'

@Component({
  components: {
    AuthModal,
    ResetPasswordForm,
  },
  head: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  },
})
export default class ResetPassword extends Vue {
  get errors(): ErrorEntities {
    return this.$store.getters.getResetPasswordPageError
  }

  get formPending(): boolean {
    return this.$store.getters.getResetPasswordPagePending
  }

  get resetPasswordToken(): string {
    return this.$route.query.reset_password_token as string
  }

  onResetPassword(formData: ResetPasswordFormData): void {
    formData.resetPasswordToken = this.resetPasswordToken

    this.$store.dispatch(AuthActionTypes.ResetPassword, formData)
  }
}
